import { render, staticRenderFns } from "./LbsReal.vue?vue&type=template&id=0e0954d2&scoped=true"
import script from "./LbsReal.vue?vue&type=script&lang=ts&setup=true"
export * from "./LbsReal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LbsReal.vue?vue&type=style&index=0&id=0e0954d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0954d2",
  null
  
)

export default component.exports